module.exports = __webpack_public_path__ + "img/close.469458b8.svg";